const actions = {
  GET_QWIK_BALANCE_BEGIN: 'GET_QWIK_BALANCE_BEGIN',
  GET_QWIK_BALANCE_SUCCESS: 'GET_QWIK_BALANCE_SUCCESS',
  GET_QWIK_BALANCE_ERR: 'GET_QWIK_BALANCE_ERR',

  GET_QWIK_MERCHANTS_BEGIN: 'GET_QWIK_MERCHANTS_BEGIN',
  GET_QWIK_MERCHANTS_SUCCESS: 'GET_QWIK_MERCHANTS_SUCCESS',
  GET_QWIK_MERCHANTS_ERR: 'GET_QWIK_MERCHANTS_ERR',

  GET_QWIK_PRODUCTS_BEGIN: 'GET_QWIK_PRODUCTS_BEGIN',
  GET_QWIK_PRODUCTS_SUCCESS: 'GET_QWIK_PRODUCTS_SUCCESS',
  GET_QWIK_PRODUCTS_ERR: 'GET_QWIK_PRODUCTS_ERR',

  UPLOAD_QWIK_PRODUCTS_FILE_BEGIN: 'UPLOAD_QWIK_PRODUCTS_FILE_BEGIN',
  UPLOAD_QWIK_PRODUCTS_FILE_SUCCESS: 'UPLOAD_QWIK_PRODUCTS_FILE_SUCCESS',
  UPLOAD_QWIK_PRODUCTS_FILE_ERR: 'UPLOAD_QWIK_PRODUCTS_FILE_ERR',

  getQwikBalanceBegin: () => {
    return {
      type: actions.GET_QWIK_BALANCE_BEGIN,
    };
  },

  getQwikBalanceSuccess: (data) => {
    return {
      type: actions.GET_QWIK_BALANCE_SUCCESS,
      data,
    };
  },

  getQwikBalanceErr: (err) => {
    return {
      type: actions.GET_QWIK_BALANCE_ERR,
      err,
    };
  },

  getQwikMerchantsBegin: () => {
    return {
      type: actions.GET_QWIK_MERCHANTS_BEGIN,
    };
  },

  getQwikMerchantsSuccess: (data) => {
    return {
      type: actions.GET_QWIK_MERCHANTS_SUCCESS,
      data,
    };
  },

  getQwikMerchantsErr: (err) => {
    return {
      type: actions.GET_QWIK_MERCHANTS_ERR,
      err,
    };
  },

  getQwikProductsBegin: () => {
    return {
      type: actions.GET_QWIK_PRODUCTS_BEGIN,
    };
  },

  getQwikProductsSuccess: (data) => {
    return {
      type: actions.GET_QWIK_PRODUCTS_SUCCESS,
      data,
    };
  },

  getQwikProductsErr: (err) => {
    return {
      type: actions.GET_QWIK_PRODUCTS_ERR,
      err,
    };
  },

  uploadQwikProductsFileBegin: () => {
    return {
      type: actions.UPLOAD_QWIK_PRODUCTS_FILE_BEGIN,
    };
  },

  uploadQwikProductsFileSuccess: (data) => {
    return {
      type: actions.UPLOAD_QWIK_PRODUCTS_FILE_SUCCESS,
      data,
    };
  },

  uploadQwikProductsFileErr: (err) => {
    return {
      type: actions.UPLOAD_QWIK_PRODUCTS_FILE_ERR,
      err,
    };
  },
};

export default actions;
